/**
 * import utils from '@/utils/utils';
 * utils.getToken(row.UId)
 *
 */

import axios from "axios";

const util = {
  async getToken(UId) {
    try {
      let response = await axios.get(
        `https://mp.yijugongshe.com/api/Common/GetUserToken`,
        {
          params: {
            uId: UId,
            passWord: "202121",
          },
        }
      );
      console.log("response>>", response);
      localStorage.setItem("token", response.data);
    } catch (error) {
      console.error("Error fetching token or copying to clipboard:", error);
    }
  },
};

export default util;
